import analytics from 'common/analytics';

import './category-group.style.sass';
import template from './category-group.tpl.pug';

class CategoryGroupController {
    /* @ngInject */
    constructor(numberUtil, arrayUtil) {
        this.numberUtil = numberUtil;
        this.arrayUtil = arrayUtil;

        this.expanded = false;
    }

    $onChanges(changeObject) {
        if (changeObject.average || changeObject.value) {
            if (changeObject.average) {
                this.average = changeObject.average.currentValue;
            }
            if (changeObject.value) {
                this.value = changeObject.value.currentValue;
            }

            this.calculateDifference(this.average, this.value);
        }
    }

    calculateDifference(average, value) {
        if (average > 0) {
            this.exceeded = value > average;
            this.difference = Math.abs(average - value);
        } else {
            this.exceeded = false;
            this.difference = 0;
        }

        this.averagePercent = this.getPercentage(average, value);
        this.valuePercent = this.getPercentage(value, average);
    }

    getPercentage(value1, value2) {
        return `${this.numberUtil.convertToPercentage(value1 / value2 * 100)}%`;
    }

    get hasPastData() {
        return !!this.average;
    }

    toggleGroupVisibility() {
        this.expanded = !this.expanded;

        analytics.trackDashboardToggleCategoryGroup();
    }

    clickEventGroup() {
        analytics.trackDashboardClickEventGroup();
    }
}

export default {
    selector: 'dbACategoryGroup',
    template: template(),
    controller: CategoryGroupController,
    bindings: {
        name: '<',
        color: '<',
        average: '<',
        value: '<',
        eventGroups: '<',
        exceededText: '<',
        savedText: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/category-group/category-group.cmpt.js